export default __webpack_public_path__ + "static/media/cover.521b8ccd.jpg";